'use strict';

bbw.directive.sticky = ['bbw.LayoutTypeSvc', '$document', '$timeout', function(layoutTypeSvc, $document, $timeout) {

    var namespace = 'sticky';

    return {
        link: function(scope, angularElement, attrs) {
            var hasTouch = 'ontouchstart' in $document[0].documentElement;
            var alwaysSticky = false;
            var stickyRight = false;

            if ('stickyAlwaysOnTouch' in attrs && hasTouch) {
                alwaysSticky = true;
            }
            if ('stickyRight' in attrs && hasTouch) {
                stickyRight = true;
            }

            var parseLimit = function(value) {
                value = scope.$eval(value);
                if (angular.isObject(value)) {
                    for (var key in value) {
                        //noinspection JSUnfilteredForInLoop
                        value[key] = parseFloat(value[key]);
                    }
                } else {
                    value = parseFloat(value);
                }
                return value;
            };

            var getLimitByMedia = function(value) {
                var result;
                if (angular.isObject(value)) {
                    result = value[layoutTypeSvc.getLayoutType()];
                } else {
                    result = value;
                }
                if (angular.isUndefined(result)) {
                    result = NaN;
                }
                return result;
            };

            var
                // get element
                element = angularElement[0],

                // get document
                document = element.ownerDocument,

                // get window
                window = document.defaultView,

                // get wrapper
                wrapper = document.createElement('span'),

                // cache style
                style = element.getAttribute('style'),

                // get options
                bottomLimit = parseLimit(attrs[namespace + 'Bottom']),
                media = window.matchMedia(attrs[namespace + 'Media'] || 'all'),
                topLimit = parseLimit(attrs[namespace + 'Top']),

                // initialize states
                activeBottom = false,
                activeTop = false,
                offset = {};

            // configure wrapper
            wrapper.className = angular.isDefined(attrs[namespace + 'Class'])
                ? attrs[namespace + 'Class'] : 'is-' + namespace;

            var isActivated = false, wrapperWidth, wrapperHeight, elementWidth, windowWidth;

            function updateRect() {
                if (isActivated) {
                    var windowWidth = document.documentElement.offsetWidth;
                    if (element.offsetWidth != wrapperWidth || wrapperWidth > windowWidth) {
                        wrapperWidth = Math.min(windowWidth, element.offsetWidth);
                        wrapper.style.width = '' + wrapperWidth + 'px';
                        elementWidth = wrapper.offsetWidth;
                        element.style.width = '' + elementWidth + 'px';
                    }
                    if (element.offsetHeight != wrapperHeight) {
                        wrapperHeight = element.offsetHeight;
                        wrapper.style.height = '' + wrapperHeight + 'px';
                    }
                }
            }

            var activeElement = undefined;
            var checkActiveElement = function() {
                if (document.activeElement && element.contains(document.activeElement)) {
                    activeElement = document.activeElement;
                } else {
                    activeElement = undefined;
                }
            };
            var restoreActiveElement = function() {
                if (activeElement) {
                    activeElement.focus && activeElement.focus();
                }
                activeElement = undefined;
            };

            // activate sticky
            function activate(noActElement) {
                // get element computed style
                var
                    top = getLimitByMedia(topLimit),
                    bottom = getLimitByMedia(bottomLimit),
                    computedStyle = getComputedStyle(element),
                    position = activeTop ? 'top:' + top : 'bottom:' + bottom,
                    parentNode = element.parentNode,
                    nextSibling = element.nextSibling;

                noActElement || checkActiveElement();

                // replace element with wrapper containing element
                wrapper.appendChild(element);

                if (parentNode) {
                    parentNode.insertBefore(wrapper, nextSibling);
                }

                windowWidth = document.documentElement.offsetWidth;
                wrapperWidth = Math.min(windowWidth, element.offsetWidth);
                wrapperHeight = element.offsetHeight;

                // style wrapper
                wrapper.setAttribute('style', 'display:' + computedStyle.display + ';height:' + element.offsetHeight + 'px;margin:' + computedStyle.margin + ';width:' + Math.min(document.documentElement.offsetWidth, element.offsetWidth) + 'px');

                elementWidth = wrapper.offsetWidth;

                // style element
                element.setAttribute('style', (stickyRight ? ('right:' + (stickyRight|| '0')) : ('left:' + (offset.left || 0))) + 'px;margin:0;position:fixed;transition:none;' + position + 'px;width:' + elementWidth + 'px');

                noActElement || restoreActiveElement();

                isActivated = true;
            }

            // deactivate sticky
            function deactivate(force, noActElement) {
                if (alwaysSticky && !force) {
                    return;
                }

                var
                    parentNode = wrapper.parentNode,
                    nextSibling = wrapper.nextSibling;

                isActivated = false;

                if (!parentNode) {
                    return;
                }

                noActElement || checkActiveElement();

                // replace wrapper with element
                parentNode.removeChild(wrapper);

                parentNode.insertBefore(element, nextSibling);

                // unstyle element
                if (style === null) {
                    element.removeAttribute('style');
                } else {
                    element.setAttribute('style', style);
                }

                // unstyle wrapper
                wrapper.removeAttribute('style');

                noActElement || restoreActiveElement();

                activeTop = activeBottom = false;
            }

            // window scroll listener
            function onscroll() {
                if (alwaysSticky && !isActivated) {
                    activate();
                    return;
                }

                var top = getLimitByMedia(topLimit),
                    bottom = getLimitByMedia(bottomLimit);
                try {
                    // if activated
                    if (activeTop || activeBottom) {
                        // get wrapper offset
                        offset = wrapper.getBoundingClientRect();

                        activeBottom = !isNaN(bottom) && offset.top > window.innerHeight - bottom - wrapper.offsetHeight;
                        activeTop = !isNaN(top) && offset.top < top;

                        // deactivate if wrapper is inside range
                        if (!activeTop && !activeBottom) {
                            try {
                                deactivate();
                            } catch (e) {
                                // pass
                            }
                        }
                    }
                    // if not activated
                    else if (media.matches) {
                        // get element offset
                        offset = element.getBoundingClientRect();

                        activeBottom = !isNaN(bottom) && offset.top > window.innerHeight - bottom - element.offsetHeight;
                        activeTop = !isNaN(top) && offset.top < top;

                        // activate if element is outside range
                        if (activeTop || activeBottom) {
                            try {
                                activate();
                            } catch (e) {
                                // pass
                            }
                        }
                    }
                } catch (e) {
                    // pass
                }
            }

            // window resize listener
            function onresize() {
                if (alwaysSticky) {
                    if (windowWidth == document.documentElement.offsetWidth) {
                        return;
                    }
                    checkActiveElement();
                    deactivate(true, true);
                    activate(true);
                    restoreActiveElement();
                } else {
                    if (isActivated) {
                        deactivate();
                    }
                    onscroll();
                }

            }

            // destroy listener
            function ondestroy() {
                deactivate();

                window.removeEventListener('scroll', onscroll);
                window.removeEventListener('resize', onresize);
            }

            // bind listeners
            window.addEventListener('scroll', onscroll);
            window.addEventListener('resize', onresize);

            scope.$on('$destroy', ondestroy);
            angularElement.on('$destroy', ondestroy);

            // initialize sticky
            onscroll();

            $timeout(function() {
                if (isActivated) {
                    updateRect();
                }
            }, 500);

            scope.$watch(function() {
                if (isActivated) {
                    updateRect();
                }
                setTimeout(onscroll, 0);
            });
        }
    };
}];
